import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

export const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  url: 'api/files/sts-credentials',
  maxFilesize: 10000,
  uploadMultiple: true,
  maxFiles: 100,
  parallelUploads: 1,
  addRemoveLinks: true,
  autoProcessQueue: false,
  acceptedFiles:
    // eslint-disable-next-line max-len
    '.jpeg, .jpg, .png, .jfif .gif, .mp4, .webm, .ogg, .flv, .avi, .wmv, .mpg, .wav, .mpeg, .m4v, .mkv, .mov, .pdf, .mp3, .au, .wma, .doc, .docx, .xls, .text,.xlsx, .msword, .vnd.openxmlformats-officedocument.wordprocessingml.document, .vnd.openxmlformats-officedocument.spreadsheetml.sheet, .vnd.ms-excel',
};

export interface IDropzoneFile extends File {
  previewElement: HTMLElement;
  previewTemplate: HTMLElement;
  previewsContainer: HTMLElement;
  status: string;
  accepted: boolean;
}

export interface IDropzoneErrorEvent {
  0: IDropzoneFile;
  1: string;
}
